// Function loadProductItemCarouselWidget loads the ProductItemCarouselWidget class by dynamically importing the js on demand if needed

export function loadProductItemCarouselWidget($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-product-item-carousel-widget-chunk" */ '../widgets/productItemCarouselWidget').then(wg => {

		const { ProductItemCarouselWidget } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ProductItemCarouselWidget"]');

		if(!$wg) {
			// console.info('ProductItemCarouselWidget: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ProductItemCarouselWidget"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ProductItemCarouselWidget($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ProductItemCarouselWidget($wg);
		}


	}).catch(error => error+'An error occurred while loading the ProductItemCarouselWidget widget');

}
